<template>
  <div class="location-leader">
    <div class="card">
      <div class="card-body">
        <h2
          v-if="header"
          class="text-center"
        >{{ header }}</h2>

        <div class="my-2">
          <participant-winner-item
            v-for="participant in value"
            :key="participant.id"
            :value="participant"
            class="w-100"
          />
        </div>
        <div class="text-center">
          <slot name="buttons">
            <a
              v-if="hasFeature('showResults')"
              v-track-click="'Participant Leaderboard'"
              class="btn btn-outline-primary w-100"
              :href="$resultsUrl"
              target="_blank"
              rel="noopener"
            >
              {{ $t('results.btn') }}
            </a>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ParticipantWinnerItem from '@/components/list/ParticipantWinnerItem.vue'
import { mapGetters } from 'vuex'
import * as modes from '@/constants/modes'

export default {
  name: 'LocationLeaders',
  modes,
  components: {
    ParticipantWinnerItem
  },
  props: {
    value: {
      type: Array,
      default: undefined
    },
    header: {
      type: String,
      default: undefined
    }
  },
  computed: {
    ...mapGetters([
      'mode',
      'hasFeature'
    ])
  }
}
</script>
